import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";


const vUI_Baseline_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_BASELINE_ID:         {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Baseline WB Id',
            columnResourceName: 'colId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    BASELINE_ID:            {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Ref. Baseline ID',
            columnResourceName: 'colBaselineId',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50}
    },
    BASELINE_NAME:          {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Ref. Baseline Name',
            columnResourceName: 'colName',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 256}
    },
    BASELINE_SOURCE_ID:     {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Source',
            columnResourceName: 'colSourceId',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50}
    },
    BASELINE_TYPE_ID:       {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Baseline Type',
            columnResourceName: 'colBaselineType',
            alignment: HorizAlignment.Left},
        domainOptions: { maxLength: 50}
    },
    LAST_REFRESH_DT:        {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Last Refresh Date',
            columnResourceName: 'colRefreshDate',
            alignment: HorizAlignment.Right},
        domainOptions: { maxLength: 50}
    },
    HIST_DATATHRU_DT:       {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Historical Data Through Date',
            columnResourceName: 'colDataThruDate',
            alignment: HorizAlignment.Right
        },
        domainOptions: { maxLength: 50}
    },
    WB_MDSET_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Master Data Set WB Id',
            columnResourceName: 'colMDSetId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    MDSET_ID:                 {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Master Data Set Id',
            columnResourceName: 'colId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}
    },
    MDSET_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Master Data Set',
            columnResourceName: 'colMDSetName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            profileId: "default",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 256
        }
    },
    WB_SALESAREA_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'wb Sales Area',
            columnResourceName: 'colSalesAreaId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    SALESAREA_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Sales Area Id',
            columnResourceName: 'colSalesAreaId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}
    },
    SALESAREA_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Sales Area',
            columnResourceName: 'colSalesAreaName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}
    },
    WB_SALESORG_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'wb Sales Org',
            columnResourceName: 'colSalesOrgId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    SALESORG_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'SalesOrg Id', columnResourceName: 'colSalesOrgId', alignment: HorizAlignment.Left},
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}
    },
    SALESORG_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Sales Org', columnResourceName: 'colSalesOrgName', alignment: HorizAlignment.Left},
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}
    },
    WB_COMPANY_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'wb Company',
            columnResourceName: 'colCompanyId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    COMPANY_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Company Id', columnResourceName: 'colCompanyId', alignment: HorizAlignment.Left},
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}
    },
    COMPANY_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Company', columnResourceName: 'colCompanyName', alignment: HorizAlignment.Left},
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

const BaselineSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id:     'WB_BASELINE_ID',
        id_ui:  'BASELINE_ID',
        name:   'BASELINE_NAME'
    },

    searchProviderFields: vUI_Baseline_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Baseline_Search',
                this.searchProviderFields,
                [])

            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            if (!usrContext.hasRoleId("VIEW_ALL")) {
                searchRequestSubset.where['WB_MDSET_ID'] = {inq: _.map(usrContext.WB_MasterDataSets, 'WB_MDSET_ID')}
            }

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    },

    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest({},
                'vUI_Baseline_Search',
                this.searchProviderFields,
                [fieldName])

            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            if (!usrContext.hasRoleId("VIEW_ALL")) {
                findRequest.where['WB_MDSET_ID'] = {inq: _.map(usrContext.WB_MasterDataSets, 'WB_MDSET_ID')}
            }

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(_.map(res, (aRow) => { return aRow[fieldName] }))
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


const BaselineSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "BaselineSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'BASELINE_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'BASELINE_NAME', renderOptions: { }},
        {profileFilterName: 'Source ID',     searchProviderFieldId: 'BASELINE_SOURCE_ID', renderOptions: { }},
        {profileFilterName: 'Baseline Type',     searchProviderFieldId: 'BASELINE_TYPE_ID', renderOptions: { }},
        {profileFilterName: 'Master Data Set', searchProviderFieldId: 'MDSET_NAME', bMultiSelect: true, renderOptions: {}},
        {profileFilterName: 'Company', searchProviderFieldId: 'COMPANY_NAME', bMultiSelect: true, renderOptions: {}},
        {profileFilterName: 'Sales Org', searchProviderFieldId: 'SALESORG_NAME', bMultiSelect: true, renderOptions: {}},
        {profileFilterName: 'Sales Area', searchProviderFieldId: 'SALESAREA_NAME', bMultiSelect: true, renderOptions: {}}
    ],  // ISearchFields
    profileDisplayFields: [
        'BASELINE_ID', 'BASELINE_NAME', 'BASELINE_SOURCE_ID', 'BASELINE_TYPE_ID', 'MDSET_NAME', 'COMPANY_NAME', 'SALESORG_NAME',
        'SALESAREA_NAME', 'LAST_REFRESH_DT', 'HIST_DATATHRU_DT','CREATED_DTTS','MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: BaselineSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


const BaselineSearch: ISearch = {
    searchName: "Find Reference Baseline",
    renderOptions: { ui5ResourceId: "BaselineSearch" },
    searchProfileIdDefault: "default",
    searchProfiles: [BaselineSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("BaselineBO", "Baseline", BaselineSearch, "Baseline Search")
export {BaselineSearch}